import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import ResendCode from './ResendCode';

const OTPForm = ({ otp, onChange, onSubmit, error, disabled, email_id, message }) => {
  const { t } = useTranslation('auth');
  const [localError, setLocalError] = useState(error);
  const [otpLength, setOtpLength] = useState(otp?.length || 0);
  const { auth } = useSelector(state => state);
  const { failureAttempts } = auth.otp;

  useEffect(() => {
    setLocalError(error);
  }, [error, failureAttempts]);

  const handleKeyDown = e => {
    if (e.key === 'Enter' && otpLength === 6 && !disabled) {
      onSubmit();
    }
  };

  const handleInput = valueArray => {
    setOtpLength(valueArray.join('').length);
    setLocalError(false);
  };

  return (
    <>
      <Input.OTP
        formatter={v => v.replace(/\D/g, '')}
        length={6}
        value={otp}
        onChange={onChange}
        onInput={handleInput}
        status={localError ? 'error' : undefined}
        onKeyDown={handleKeyDown}
      />

      {localError && <div style={{ color: 'red', marginTop: '12px' }}>{message}</div>}

      <Button
        type="primary"
        onClick={onSubmit}
        disabled={otpLength !== 6 || disabled}
        style={{
          margin: 'auto',
          marginTop: '20px',
          width: '220px',
          display: 'block',
          height: '40px',
          borderRadius: 2,
        }}
      >
        {t('otp.submit')}
      </Button>

      <ResendCode email_id={email_id} />
    </>
  );
};

export default OTPForm;
